import { Injectable } from '@angular/core';
import manifestData from './manifest.json'; // Use import instead of require

export interface Release {
  version: string;
  changelog: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReleaseService {
  public releases: Release[] = manifestData;

  public getLatestVersion(): string {
    return this.releases[0].version;
  }

  public getAllReleases(): Release[] {
    return this.releases;
  }

  public getVersion(version: string): Release {
    return (
      this.releases.find((obj) => obj.version == version) || this.releases[0]
    );
  }
}
